import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Grid } from '@mui/material';

import { ContentIcon, Icon } from '@components/base';
import useLayoutEntityFilterContext from '@hooks/useLayoutEntityFilter';
import Collection from '@models/Collection';

const LayoutEntityFilterChips: FC = () => {
  const { t } = useTranslation();
  const { clearFilterChips, tagValues, typeValues } = useLayoutEntityFilterContext<Collection>();

  if (!tagValues && !typeValues) return null;

  const { tagCombinator, tags, removeTag } = tagValues || {};
  const { types, removeType } = typeValues || {};

  const hasFilters = (tags && tags.length > 0) || (types && types.length > 0);

  return hasFilters ? (
    <div>
      <Grid container spacing={1}>
        <Grid>
          <Chip
            label={t('clearFilters')}
            onClick={clearFilterChips}
            size='small'
            variant='contrast'
          />
        </Grid>

        {tagCombinator &&
          removeTag &&
          tags?.map(tag => (
            <Grid key={tag}>
              <Chip
                icon={<Icon name='tag' />}
                label={tag}
                onDelete={() => removeTag(tag)}
                size='small'
              />
            </Grid>
          ))}

        {removeType &&
          types?.map(type => (
            <Grid key={type}>
              <Chip
                icon={<ContentIcon contentType={type} hideTooltip />}
                label={t(`contentType.${type}`, { context: 'minified' })}
                onDelete={() => removeType(type)}
                size='small'
              />
            </Grid>
          ))}
      </Grid>
    </div>
  ) : null;
};

export default LayoutEntityFilterChips;
